import React from 'react'

import { ZariContext } from '_zari/context'

import { Modal, Button } from '_zari/core'

import { RounderUtil, IdGen } from 'utils'

import * as OrdenCompraService from 'services/ordenCompra.service'

import * as Sections from './sections'

const InfoOrdenModal = ({
  handleClose,
  show,
  idOrdenCompra,
  setValues,
  values,
  dispatch,
  toggleListaOrdenesModal,
  flagVerOrdenesCerradas
}) => {
  const __zariContext = React.useContext(ZariContext)

  const infoOrdenRef = React.useRef({})

  const [detallesOrden, setDetallesOrden] = React.useState([])
  const [cantidadesAsignadas, setCantidadesAsignadas] = React.useState([])

  React.useEffect(() => {
    __zariContext.loader.open('Consultando información de orden de compra')

    OrdenCompraService.getOrden_ParaCompra(idOrdenCompra)
      .then(({ data }) => {
        infoOrdenRef.current = data
        setDetallesOrden(data.detalles)

        const innerCantidadesAsignadas = []

        for (let i = 0; i < data.detalles.length; i++) {
          const detOrd = data.detalles[i]
          const movs = Array.isArray(detOrd.movimientos) ? detOrd.movimientos : []
          const ultimoMov = movs.length > 0 ? movs[movs.length - 1] : null
          const saldo = ultimoMov ? Number(ultimoMov.saldo) || 0 : 0
          innerCantidadesAsignadas[i] = saldo > 0 ? saldo : 0
        }

        setCantidadesAsignadas(innerCantidadesAsignadas)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, idOrdenCompra])

  const clickContinuar = React.useCallback(() => {
    const detallesSalida = []
    const errores = []

    for (let i = 0; i < detallesOrden.length; i++) {
      const detOrd = detallesOrden[i]
      const movs = Array.isArray(detOrd.movimientos) ? detOrd.movimientos : []
      const ultimoMov = movs.length > 0 ? movs[movs.length - 1] : null
      const saldo = ultimoMov ? Number(ultimoMov.saldo) || 0 : 0

      const cantidad = parseFloat(cantidadesAsignadas[i])

      if (cantidad === 0 || isNaN(cantidad)) {
        continue
      }

      if (cantidad < 0) {
        errores.push(`${detOrd.codigoProducto || detOrd.nombreProducto}: la cantidad no puede ser negativa.`)
        continue
      }

      if (cantidad > saldo + 0.0001) {
        errores.push(
          `${detOrd.codigoProducto || detOrd.nombreProducto}: cantidad ${cantidad} excede el saldo pendiente (${saldo}).`
        )
        continue
      }

      const subTotal = RounderUtil.round(detOrd.precio * cantidad, 4)

      detallesSalida.push({
        _idFila: IdGen.newId(),
        afectacion: detOrd.afectacion,
        codigoProducto: detOrd.codigoProducto,
        moneda: detOrd.moneda,
        nombreProducto: detOrd.nombreProducto,
        nombreUnidadDeMedida: detOrd.nombreUnidadDeMedida,
        precio: detOrd.precio,
        cantidad: cantidad,
        _idDetalleOrden: detOrd._id,
        _idProducto: detOrd._idProducto,
        _idProductoPresentacion: detOrd._idProductoPresentacion,
        flagLote: detOrd.flagLote || false,
        // `tipo` (BIEN/SERVICIO/ACTIVO_FIJO) decide si abrimos el modal de unidades
        // patrimoniales; antes solo se propagaba tipoExistencia (otro campo SUNAT)
        // y por eso no se reconocía el activo fijo en este flujo.
        tipo: detOrd.tipo || null,
        tipoExistencia: detOrd.tipoExistencia || null,
        codigoBarra: detOrd.codigoBarra || null,
        subTotal: subTotal,
        total: subTotal
      })
    }

    if (errores.length > 0) {
      __zariContext.snack('error', errores.join(' '))
      return
    }

    if (detallesSalida.length === 0) {
      __zariContext.snack('error', 'Ingrese al menos una cantidad a recibir.')
      return
    }

    values._idOrdenCompra = infoOrdenRef.current._id
    values.moneda = infoOrdenRef.current.moneda
    setValues(values)

    dispatch({ type: 'fill', payload: detallesSalida })
    handleClose()
  }, [__zariContext, detallesOrden, cantidadesAsignadas, values, setValues, dispatch, handleClose])

  return (
    <Modal show={show} onHide={handleClose} size='xl'>
      <Modal.Header>
        <Modal.Title>MOVIMIENTOS POR ORDEN DE COMPRA</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {detallesOrden.map((x, k) => (
          <Sections.DetalleOrdenSection
            key={k}
            index={k}
            infoDetalle={x}
            cantidadesAsignadas={cantidadesAsignadas}
            setCantidadesAsignadas={setCantidadesAsignadas}
            flagVerOrdenesCerradas={flagVerOrdenesCerradas}
          />
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button
          color='secondary'
          onClick={() => {
            handleClose()
            toggleListaOrdenesModal()
          }}
        >
          Cancelar
        </Button>
        {!flagVerOrdenesCerradas && <Button onClick={clickContinuar}>Continuar</Button>}
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(InfoOrdenModal)
